import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, Grid } from "@material-ui/core";

import { UploadButton } from "../../../../../components/base/UploadButton";
import { ShaDowBox } from "../../../../../components/boxes";
import SettingHeader from "../../../../../components/SettingHeader";
import UserAvtar from "./UserAvtar";
import ProfileDetails from "./ProfileDetails";
import { header, UNIT_SYSTEM } from "../../sample";
import { SettingActions } from "../../../../../components/SettingHeader/settingActions";
import { getProfileData } from "../../../../../redux/profile/actions";
import { api } from "../../../../../services";
import endPoints from "../../../../../services/apiEndPoints";
import { MessageAlert } from "../../../../../components/alerts/MessageAlert";

export const useStyles = makeStyles(() => ({
  container: {
    marginLeft: 50,
    paddingTop: 40,
    paddingBottom: 80,
  },
  inputContainer: {
    marginTop: 30,
    display: "flex",
  },
  rightContainer: {
    marginLeft: 90,
    marginTop: 20,
  },
  saveButtonContainer: {
    paddingRight: 30,
  },
}));

export const MyProfile = () => {
  const classes = useStyles();
  const [errors, setErrors] = useState({});
  const [uploading, setuploading] = useState(false);
  const { profileData } = useSelector((state) => state.profile);
  const [user, setUser] = useState({
    username: "",
    unit_system: UNIT_SYSTEM[0],
    currency: "",
    email: "",
    avatar_url: "",
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (profileData) {
      setUser({
        username: `${profileData.first_name} ${profileData.last_name}`,
        unit_system: profileData.unit_system?.toUpperCase(),
        currency: profileData.currency,
        email: profileData.email,
        avatar_url: profileData.avatar_url,
      });
    }
  }, [profileData]);

  const ValidateUserDetails = (user = "", imageData = "") => {
    const errorState = {
      strict: "Name Should Not Contain Any Numeric Value",
      minLength: "Name Should Have more than 4 characters",
      empty: "Name Should Not be empty",
    };
    const errors = {};
    let first_name = "";
    let last_name = "";
    if (user) {
      const letters = /^[a-zA-Z ]*$/;
      if (!letters.test(user)) {
        errors["userName"] = errorState.strict;
      }
      if (user.length < 5) {
        errors["userName"] = errorState.minLength;
      }
      let nameArray = user.split(" ");
      if (nameArray.length == 1) first_name = nameArray[0];
      first_name = nameArray.slice(0, -1).join(" ");
      last_name = nameArray.slice(-1).join(" ");
    } else {
      errors["userName"] = errorState.empty;
    }
    if (imageData) {
      const imageSize = Math.floor(imageData.size / 1024);
      if (imageSize > 200) {
        errors["image"] = "File size should not exceeds 200KBs";
      }
    }
    return {
      first_name,
      last_name,
      errors,
    };
  };

  const updateInfo = async (imageData = "", unitSystem = "", userCurrency = user.currency) => {
    try {
      setErrors({});
      const data = new FormData();
      const { first_name, last_name, errors } = ValidateUserDetails(user.username, imageData);
      setErrors(errors);
      if (Object.keys(errors).length > 0) {
        return;
      }
      if (imageData) {
        data.append("avatar", imageData);
      }
      if (unitSystem) {
        data.append("unit_system", unitSystem);
      }

      data.append("currency", userCurrency);
      data.append("first_name", first_name);
      data.append("last_name", last_name);

      try {
        const response = await api.patch(endPoints.GET_PROFILE_DATA, data);
        if (response?.status === 200) {
          dispatch(getProfileData());
        }
      } catch (error) {
        console.log(error);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  const uploadImage = (e) => {
    setuploading(true);
    updateInfo(e.target.files[0]);
    setuploading(false);
  };

  return (
    <>
      <SettingActions />
      <ShaDowBox>
        <Grid container className={classes.container}>
          <SettingHeader
            title={header.myprofile.title}
            subtitle={header.myprofile.subtitle}
            img={header.myprofile.img}
          />
          <Grid item xs={6} className={classes.inputContainer}>
            <ProfileDetails
              user={user}
              errors={errors}
              setErrors={setErrors}
              setUserName={(username) =>
                setUser((prev) => ({
                  ...prev,
                  username: username,
                }))
              }
              updateInfo={updateInfo}
            />

            <Grid item xs={9} className={classes.rightContainer}>
              <UserAvtar
                uploadImage={uploadImage}
                user={user}
                UploadButton={UploadButton}
                uploading={uploading}
              />
            </Grid>
          </Grid>
        </Grid>
      </ShaDowBox>
      {errors?.image && (
        <MessageAlert
          text={errors.image}
          allowClose
          onClose={() => setErrors({ ...errors, image: "" })}
        />
      )}
    </>
  );
};
